import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Button, Grid, TextField } from "@material-ui/core";
import { toast } from "react-toastify";
import api from "../../services/api";
import { mensagemErro } from "../../services/acesso";
import Logo from "../../assets/imgs/prospect_brasil.png";
import LogoBora from "../../assets/imgs/bora.png";
import "../Login/styles.css";

const RedefinirSenha = () => {
    const { codigo } = useParams();
    const [valido, setValido] = useState(false);
    const [erro, setErro] = useState("");
    const [password, setPassword] = useState("");
    const [passwordConfirmation, setPasswordConfirmation] = useState("");
    const [loading, setLoading] = useState(false);
    const [concluido, setConcluido] = useState(false);

    useEffect(() => {
        api.get(`redefinir-senha/${codigo}`)
            .then((result) => {
                if (result.data?.valido) setValido(true);
                else setErro("Link inválido");
            })
            .catch((e) => setErro(mensagemErro(e, "Link inválido ou expirado")));
    }, [codigo]);

    const salvar = async (event) => {
        event.preventDefault();
        if (!password || password.length < 8) {
            toast.error("A senha precisa ter no mínimo 8 caracteres");
            return;
        }
        if (password !== passwordConfirmation) {
            toast.error("A confirmação da senha não confere");
            return;
        }
        setLoading(true);
        try {
            await api.post(`redefinir-senha/${codigo}`, {
                password,
                password_confirmation: passwordConfirmation,
            });
            setConcluido(true);
            toast.success("Senha redefinida");
        } catch (e) {
            toast.error(mensagemErro(e, "Não foi possível redefinir a senha"));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="bodylogin">
            <form className="form_login" onSubmit={salvar}>
                <div className="logo-form-login">
                    <img src={Logo} width={200} alt="Prospect Brasil" />
                </div>
                <h2 style={{ textAlign: "center" }}>Nova senha</h2>
                {erro && <p style={{ color: "#c62828", textAlign: "center" }}>{erro}</p>}
                {valido && !concluido && (
                    <>
                        <Grid item style={{ paddingTop: 16 }}>
                            <TextField required type="password" label="Nova senha" value={password} onChange={(e) => setPassword(e.target.value)} helperText="Mínimo de 8 caracteres" fullWidth />
                        </Grid>
                        <Grid item style={{ paddingTop: 16 }}>
                            <TextField required type="password" label="Confirmar senha" value={passwordConfirmation} onChange={(e) => setPasswordConfirmation(e.target.value)} fullWidth />
                        </Grid>
                        <Grid item style={{ paddingTop: 24, display: "flex", justifyContent: "center" }}>
                            <Button variant="contained" color="primary" type="submit" disabled={loading}>Salvar senha</Button>
                        </Grid>
                    </>
                )}
                {concluido && (
                    <Grid item style={{ paddingTop: 16, textAlign: "center" }}>
                        <p>Senha atualizada. Entre com a senha nova.</p>
                        <Button variant="contained" color="primary" onClick={() => { window.location.href = "/login"; }}>
                            Ir para o login
                        </Button>
                    </Grid>
                )}
            </form>
            <div className="logo-bora">
                <img src={LogoBora} width={200} alt="" />
            </div>
        </div>
    );
};

export default RedefinirSenha;
